/**
 * イベント種別の定数定義
 */
export const EVENT_TYPE = {
  UPCOMING: "UPCOMING EVENT",
  VOD: "VIDEO ON DEMAND",
  ARCHIVE: "ARCHIVE EVENT",
  EVENT: "EVENT",
} as const;

type EventTypeBase = typeof EVENT_TYPE;

/**
 * "UPCOMING EVENT" | "VIDEO ON DEMAND" | "ARCHIVE EVENT" | "EVENT"
 */
export type EventType = EventTypeBase[keyof EventTypeBase];
